import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import MasterLayout from "../../../masterLayout/MasterLayout";
import axios from "axios";
import { baseUrl } from "../../../helper/urls";
import CustomTable from "../../../components/custom_table/CustomTable";
import { createMRTColumnHelper } from "material-react-table";
import { Box, Button, Chip, IconButton, Modal, Tooltip } from "@mui/material";
import PreviewIcon from "@mui/icons-material/Preview";
import moment from "moment-timezone";

export default function CompletedBookingList() {
  const { token } = useSelector((state) => state.auth);

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await axios.get(
        `${baseUrl}/bookings/getBookingCompleted`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const AllData = response.data.data || [];

      // Add formattedReqId here
      const processedData = AllData.map((item) => ({
        ...item,
        formattedReqId: `DDR000${item.reqId || ""}`,
        counselorName: `${item.c_firstname || ""} ${
          item.c_lastname || ""
        }`.trim(),
      }));

      setData(processedData);
    } catch (err) {
      console.error("Failed to fetch pending booking list", err);
      setError("Failed to fetch pending bookings. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  
    function formatUtcTimeTo12Hour(timeStr) {
      if (!timeStr) return "N/A";
      const d = new Date(timeStr);
      let h = d.getUTCHours(), m = d.getUTCMinutes(), s = d.getUTCSeconds();
      const ampm = h >= 12 ? "PM" : "AM";
      h = h % 12 || 12;
      return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")} ${ampm}`;
    }
  
    function formatUtcTimeTo12HourAdd1hour(timeStr) {
      if (!timeStr) return "N/A";
      const d = new Date(timeStr);
      d.setUTCHours(d.getUTCHours() + 1); // Add 1 hour
      let h = d.getUTCHours(), m = d.getUTCMinutes(), s = d.getUTCSeconds();
      const ampm = h >= 12 ? "PM" : "AM";
      h = h % 12 || 12;
      return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")} ${ampm}`;
    }
  const getTimeZoneAbbreviation = () => {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return moment.tz(timeZone).format("z");
  };
  const timeZoneAbbreviation = getTimeZoneAbbreviation();
    const convertSlotsToStudentTimezone1 = (utcTime, type, duration = 60) => {
      if (!utcTime || !type) return "Invalid input";
  
      const studentTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const startLocal = moment.utc(utcTime).tz(studentTimeZone);
      const tzAbbr = startLocal.format("z"); 
      console.log('clllllllll',studentTimeZone,tzAbbr)
      const endLocal = moment(startLocal).add(duration, "minutes");
  
      switch (type) {
        case "date":
          return startLocal.format("YYYY-MM-DD");
        case "start":
          return startLocal.format("hh:mm:ss A");
        case "end":
          return endLocal.format("hh:mm:ss A");
        default:
          return "Invalid type";
      }
    };
  

  const columnHelper = createMRTColumnHelper();
  const columns = [
    columnHelper.accessor("actions", {
      header: "Actions",
      Cell: ({ cell }) => {
        const rowId = cell.row.original.id;
        const summary = cell.row.original.summary;
        return (
          <Box>
            <Tooltip title="View Session Summary">
              <IconButton
                color="success"
                onClick={() => {
                  handleOpenSummary();
                  setrowSummary(summary);
                }}
              >
                <PreviewIcon />
              </IconButton>
            </Tooltip>
          </Box>
        );
      },
    }),
    columnHelper.accessor("counselorName", {
      header: "Counselor Name",
      size: 40,
    }),
   columnHelper.accessor("booking_date", {
      header: "Slot Date (UTC)",
      size: 20,
      // Cell: (cell) => cell.row.original?.booking_date?.split("T")[0],
      Cell: (cell) => cell.row.original.utcTime?.split("T")[0] || "N/A",
    }),
    columnHelper.accessor("start_time", {
      header: "Start time (UTC)",
      size: 20,
      // Cell: (cell) => cell.row.original?.start_time || "--",
      Cell: (cell) => formatUtcTimeTo12Hour(cell.row.original.utcTime),
    }),
    columnHelper.accessor("end_time", {
      header: "End time (UTC)",
      size: 20,
      // Cell: (cell) => cell.row.original?.end_time || "--",
      Cell: (cell) => formatUtcTimeTo12HourAdd1hour(cell.row.original.utcTime),
    }),
    columnHelper.accessor("booking_date", {
      id: "booking_date_local",
      header: `Slot Date (${timeZoneAbbreviation})`,
      size: 20,
      // Cell: (cell) => cell.row.original?.booking_date?.split("T")[0],
      Cell: (cell) => convertSlotsToStudentTimezone1(cell.row.original.utcTime,"date"),
    }),
    columnHelper.accessor("start_time", {
        id: "start_time_local",
      header: `Start time (${timeZoneAbbreviation})`,
      size: 20,
      // Cell: (cell) => cell.row.original?.start_time || "--",
      Cell: (cell) => convertSlotsToStudentTimezone1(cell.row.original.utcTime,"start"),
    }),
    columnHelper.accessor("end_time", {
        id: "end_time_local",
      header: `End time(${timeZoneAbbreviation})`,
      size: 20,
      // Cell: (cell) => cell.row.original?.end_time || "--",
      Cell: (cell) => convertSlotsToStudentTimezone1(cell.row.original.utcTime,"end"),
    }),

    // columnHelper.accessor("created_at", {
    //   header: "Created At",
    //   size: 20,
    //   Cell: (cell) => cell.row.original?.created_at?.split("T")[0],
    // }),
    columnHelper.accessor("formattedReqId", {
      header: "Request ID",
      size: 20,
    }),
  ];

  const [openSummary, setOpenSummary] = React.useState(false);
  const handleOpenSummary = () => setOpenSummary(true);
  const handleCloseSummary = () => setOpenSummary(false);
  const [rowSummary, setrowSummary] = useState("");

  return (
    <MasterLayout>
      <>
        <CustomTable columns={columns} data={data} loading={loading} />
        <Modal
          open={openSummary}
          onClose={handleCloseSummary}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 600,
              bgcolor: "background.paper",
              border: "1px solid #fff",
              boxShadow: 24,
              p: 3,
            }}
          >
            <Box>{rowSummary ? rowSummary : "No summary available"}</Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mt: 2,
              }}
            >
              <Button
                variant="contained"
                color="error"
                onClick={handleCloseSummary}
              >
                Cancel
              </Button>
            </Box>
          </Box>
        </Modal>
      </>
    </MasterLayout>
  );
}
